export default __webpack_public_path__ + "static/media/quickeningdeath.d3786a8b.png";